var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "relative overflow-x-hidden",
      class: {
        hidden: !_vm.loading && (!_vm.recipes || _vm.recipes.length === 0),
      },
      attrs: { id: _vm.id },
    },
    [
      _c(
        "div",
        { staticClass: "container flex flex-col gap-md" },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  key: "loading",
                  staticClass: "flex col-span-12 justify-center",
                },
                [_vm._m(0)]
              )
            : _vm.recipes && _vm.recipes.length
            ? [
                _vm._t("before"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col sm:flex-row gap-sm md:gap-md featured-grid sm:[&>*:nth-child(4)]:hidden lg:[&>*:nth-child(4)]:block",
                  },
                  _vm._l(_vm.recipes, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "featured-grid__item" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "block",
                            attrs: {
                              href:
                                _vm.possibleLangPrefix +
                                "/recepten/" +
                                item.slug,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col sm:h-[380px] md:h-[600px]",
                              },
                              [
                                item.media.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "w-full h-full relative" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "relative h-[300px] sm:absolute top-0 left-0 w-full sm:h-full",
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "w-full h-full object-cover lazyload",
                                              attrs: {
                                                "data-src": item.media[0].url,
                                                alt: item.title,
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "shrink-0 relative overflow-hidden | featured-grid__item-title",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-between my-sm sm:my-md",
                                      },
                                      [
                                        _c("h3", {}, [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(item.title) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._m(1, true),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._t("after"),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center",
      },
      [
        _c("i", {
          staticClass:
            "fa-regular fa-spinner-third h-[60px] w-auto animate-spin",
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "w-lg h-lg rounded-full border border-primary-400 shrink-0 ml-sm text-primary-400 flex items-center justify-center",
      },
      [_c("i", { staticClass: "fa-regular fa-arrow-right" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }